import { Component, OnInit, Output, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DpDatePickerModule, } from 'ng2-date-picker';
import * as moment from 'moment';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CalendarSlotComponent } from '../calendar-slot/calendar-slot.component';
import { BaseForm } from '../../../../../../../shared/product/baseForm';
import { FormValidatorService } from '../../../../../../../shared/services/form-validator.service';
import { Validators } from '../../../../../../../shared/validators';
import { CustomValidators } from '../../../../../../../shared/custom-validators';
import { SlotsService } from '../calendar-slot/slots.service';
import { IModifiedServerSlotObject } from '../../calendarSlots.interface';
import { MatCalendar } from '@angular/material/datepicker';

@Component({
  selector: 'app-calendar-step-two',
  templateUrl: './calendar-step-two.component.html',
  styleUrls: ['./calendar-step-two.component.scss'],
  providers: [DpDatePickerModule, MatFormFieldModule],
})
export class CalendarStepTwoComponent extends BaseForm implements OnInit {
  daysSelected: string[] = [];
  constructor(
    private slotsService: SlotsService,
  ) {
    super();
    this.formValidator = new FormValidatorService();
  }
  @ViewChild(CalendarSlotComponent) public slots!: CalendarSlotComponent;
  @ViewChild('calendar') calendar: MatCalendar<Date>;
  @Output() hasNoSlot = new EventEmitter();
  formValidator: any;
  stepForm!: FormGroup;
  today: Date = new Date()
  minDate: Date = new Date(
    this.today.getFullYear(),
    this.today.getMonth() ,
    this.today.getDate() + 1
  );
  maxDate: Date = new Date(
    this.today.getFullYear(),
    this.today.getMonth() + 1,
    this.today.getDate()
  );
  controllers = {
    image: {
      fieldName: "Calendar Image",
      fieldNameAr: "صورة النتيجة",
      fieldType: "product_image",
      isStaticUI: true,
      defaultValue: "",
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
      ],
    },
    price: {
      fieldName: "Price",
      fieldNameAr: "السعر",
      fieldType: "price",
      isStaticUI: true,
      defaultValue: "",
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
        {
          validatorFn: Validators.min(1),
          message: `${this.validationMsg.min}1`,
          messageAr: `${this.validationMsgAr.min}الـ1`
        },
        {
          validatorFn: CustomValidators.requiredNumber,
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`
        },
      ],
    },
    maxAttendees: {
      fieldName: "Max Quantity (per slot)",
      fieldNameAr: "أقصى كمية (لكل فترة)",
      fieldType: "maxAttendees",
      isStaticUI: true,
      defaultValue: "",
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
        {
          validatorFn: Validators.min(1),
          message: `${this.validationMsg.min}1`,
          messageAr: `${this.validationMsgAr.min}الـ1`
        },
        {
          validatorFn: CustomValidators.requiredNumber,
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`
        },
      ],
    },
    maxQuantity: {
      fieldName: "Max Quantity Per Sale",
      fieldNameAr: "أقصى كمية لكل عملية بيع",
      fieldType: "maxQuantityPerSale",
      isStaticUI: true,
      defaultValue: null,
      validators: [
        {
          validatorFn: CustomValidators.lessThanOtherField("Total Quantity"),
          message: `${this.validationMsg.lessThanOtherField}available quantity.`,
          messageAr: `${this.validationMsgAr.lessThanOtherField}الكمية المتوفرة.`
        },
      ],
    },
    Slots: {
      fieldName: "Slots",

      fieldType: "product_image",
      isStaticUI: true,
      defaultValue: "",
      validators: [],
    },
    is_buyer_info: {
      fieldName: "Do you want to Add extra Buyer info fields to your product?",
      fieldNameAr: "هل تريد ان تأخذ معلومات اضافية من المشتري؟",
      fieldType: "Do you want to Add extra Buyer info fields to your product?",
      isStaticUI: true,
      defaultValue: "",
      validators: [],
    },
  };
  isUpdate: any;
  productTypeId: any;
  noSlot: boolean = true;

  ngOnInit() {
    this.stepForm = this.formValidator.createForm(
      Object.values(this.controllers)
    );

    this.fromControllers = this.stepForm;
    this.stepForm.markAsUntouched();
  }

  updateValue(value: any) {
    this.hasNoSlot.emit(value);
    this.noSlot = value;
  }

  convertControls(name: string) {
    return this.stepForm.get(name) as FormControl;
  }

  updateDaysSlotsValuesInCaseOfEdit(days: IModifiedServerSlotObject[]){
    days.forEach((day, dayIndex) => {
      this.handleDateChange(new Date(day.day), this.calendar)
      day.slots.forEach((slot, slotIndex) => {
        this.slots.addDaySlots(dayIndex)
        this.slots.getDaySlot(dayIndex, slotIndex).patchValue({
          id: slot.id,
          startAt: moment(slot.startAt, "hh:mm:ss A").format("HH:mm"),
          endAt: moment(slot.endAt, "hh:mm:ss A").format("HH:mm")
        })
      })
      this.slots.removeDaySlot(dayIndex, day.slots.length) //remove the slot created by default
    })
  }

  handleDateChange(event, calendar){
    const date =
    ("00" + event.getDate()).slice(-2) +
    "-" +
    ("00" + (event.getMonth() + 1)).slice(-2) +
    "-" +
    event.getFullYear();
    const index = this.daysSelected.findIndex(x => x == date);
    if (index < 0) this.daysSelected.push(date);
    else this.daysSelected.splice(index, 1);

    calendar.updateTodaysDate();
    this.slotsService.daysUpdated.emit(date);
  }

  dateClass(event: Date) {
    const date =
    ("00" + event.getDate()).slice(-2) +
    "-" +
    ("00" + (event.getMonth() + 1)).slice(-2) +
    "-" +
    event.getFullYear();
    return this.daysSelected.find(x => x == date) ? "special-date" : null;
  }

  onReflectScheduleDatesToCalender(scheduledDays:string[]){
    this.daysSelected=scheduledDays;
    this.calendar.updateTodaysDate();
  }
}
